import React, { useState, useEffect } from 'react';
import { Divider } from 'antd';
import { SchedulePageToolbar } from './SchedulePageToolbar';
import { ScheduleList } from './ScheduleList';
export const SchedulePage = (props) => {
    const { event_id, schedule, pageItem, pageData, pages, disabled } = props;
    const [currentPageData, setCurrentPageData] = useState(pageData);
    const [isEditing, setIsEditing] = useState(false);
    useEffect(() => {
        setCurrentPageData(pageData);
    }, [pageData]);
    return (React.createElement(React.Fragment, null,
        React.createElement(SchedulePageToolbar, { event_id: event_id, pageItem: pageItem, currentPageData: currentPageData, schedule: schedule, isEditing: isEditing, setIsEditing: setIsEditing, disabled: disabled }),
        React.createElement(Divider, null),
        React.createElement(ScheduleList, { event_id: event_id, currentPageData: currentPageData, schedule: schedule, isEditing: isEditing, disabled: disabled })));
};
